export const SHOW_LOYALTY_REWARDS_LOGO = false;
